// extracted by mini-css-extract-plugin
module.exports = {"links":"n","linksContainer":"o","title":"p","link":"q"};